function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useGrid } from '../hook';

const Head = ({
  sortIcon
}) => {
  const {
    columns,
    actions = [],
    sortProps,
    collapsible,
    isDraggable,
    sort,
    perPage,
    page,
    filters
  } = useGrid();
  const tableState = {
    perPage,
    page,
    filters,
    sort
  };
  return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, isDraggable && /*#__PURE__*/React.createElement("th", {
    style: {
      width: 20
    }
  }), !!collapsible && /*#__PURE__*/React.createElement("th", {
    style: {
      width: 20
    }
  }), columns.map((column, index) => {
    const style = column.label === 'Actions' && column.dataIndex === '' ? {
      textAlign: 'center',
      width: `10px`
    } : column.labelStyle;
    const isShowColumn = column.showColumnWhen ? column.showColumnWhen(tableState) : true;
    if (!isShowColumn) return null;
    const finalLabel = typeof column.label === 'function' ? /*#__PURE__*/React.createElement(column.label, tableState) : column.label;

    if (column.sortable) {
      return /*#__PURE__*/React.createElement("th", _extends({
        key: index
      }, sortProps({
        dataIndex: column.dataIndex,
        sortOrder: column.sortDirection,
        render: _order => /*#__PURE__*/React.createElement("div", {
          className: "column"
        }, /*#__PURE__*/React.createElement("div", {
          className: "column-title"
        }, finalLabel), /*#__PURE__*/React.createElement("span", {
          className: "column-sort-icon"
        }, sortIcon))
      }), {
        style: style
      }));
    } else {
      return /*#__PURE__*/React.createElement("th", {
        key: index,
        style: style
      }, finalLabel);
    }
  })));
};

export default Head;